import classNames from 'classnames'
import styles from './ProgressBar.module.scss'

type ProgressBarProps = {
  progress: number
  className?: string
}

export const ProgressBar = (props: ProgressBarProps) => {
  return <div className={classNames(styles.progressBar, props.className)}>
    <div className={styles.progressBarInner} style={{ width: `${props.progress * 100}%` }}></div>
  </div>
}
